import getI18nProps from '@/utils/i18/getI18nProps';
import CatchError from '@/components/system/CacthError';
import MoonDraw from '@/components/features/casino/moon-draw';

// export const runtime = 'experimental-edge';
const CasinoOriginalsPage = ({ game, onRemove }) => {
  return (
    <>
      <MoonDraw />
    </>
  );
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await getI18nProps({ locale })),
    },
  };
}

export default CatchError(CasinoOriginalsPage);
